import React, { useEffect, useState } from "react";
import { useMotionValue, useSpring, animate } from "framer-motion";

// Animated number. Springs toward `value`. Used live in the calculator and
// as a count-up (from `from`) when `run` flips true in the proof section.
export function AnimatedNumber({ value, from = 0, run = true, format = (n) => Math.round(n).toLocaleString() }) {
    const [display, setDisplay] = useState(run ? value : from);
    const mv = useMotionValue(from);

    useEffect(() => {
        if (!run) return;
        const controls = animate(mv, value, {
            duration: 1.4,
            ease: [0.16, 1, 0.3, 1],
            onUpdate: (v) => setDisplay(v),
        });
        return () => controls.stop();
    }, [value, run, mv]);

    return <>{format(display)}</>;
}

// Live-reactive number for slider outputs.
export function LiveNumber({ value, format = (n) => Math.round(n).toLocaleString() }) {
    const mv = useSpring(value, { stiffness: 90, damping: 18, mass: 0.6 });
    const [display, setDisplay] = useState(value);
    useEffect(() => mv.set(value), [value, mv]);
    useEffect(() => mv.on("change", (v) => setDisplay(v)), [mv]);
    return <>{format(display)}</>;
}
